export default __webpack_public_path__ + "static/media/pizza_tv_tip.23c166a1.png";